import auth from './auth'
import client from './client'
import commerce from './commerce'
import core from './core'

export default {
  core,
  client,
  commerce,
  auth,
}
